/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import JobTable from '../JobTable';

import 'rc-banner-anim/assets/index.css';
import './index.less';

// 导入所有图片资源
import aboutHumanImg from '../../public/images/about-human.png';
import humanValueImg from '../../public/images/human-value.png';
import img2_1 from '../../public/images/2-1@2x.png';
import img2_2 from '../../public/images/2-2@2x.png';
import img2_3 from '../../public/images/2-3@2x.png';
import img2_4 from '../../public/images/2-4@2x.png';
import img2_5 from '../../public/images/2-5@2x.png';
import img2_6 from '../../public/images/2-6@2x.png';
import img2_7 from '../../public/images/2-7@2x.png';
import img2_8 from '../../public/images/2-8@2x.png';
import img2_9 from '../../public/images/2-9@2x.png';
import img2_10 from '../../public/images/2-10@2x.png';
import img2_11 from '../../public/images/2-11@2x.png';
import img2_12 from '../../public/images/2-12@2x.png';
import img2_13 from '../../public/images/2-13@2x.png';
import img2_14 from '../../public/images/2-14@2x.png';
import img2_17 from '../../public/images/2-17@2x.png';
import img2_18 from '../../public/images/2-18@2x.png';
import missionImg from '../../public/images/mission.png';
import missionDescribeImg from '../../public/images/mission-describe.png';
import integrityImg from '../../public/images/integrity.png';
import innovateImg from '../../public/images/innovate.png';
import teamworkImg from '../../public/images/teamwork.png';
import pardonImg from '../../public/images/pardon.png';
import outstandingImg from '../../public/images/outstanding.png';
import humanValuesImg from '../../public/images/human-values.png';
import carBannerImg from '../../public/images/car-banner.png';
import carDesImg from '../../public/images/car-des.png';
import part1DesImg from '../../public/images/part1-des.png';
import part2Des1Img from '../../public/images/part2-des1.png';
import part2Des2Img from '../../public/images/part2-des2.png';
import part2Des3Img from '../../public/images/part2-des3.png';
import fashionBannerImg from '../../public/images/fashion-banner.png';
import fashionDesImg from '../../public/images/fashion-des.png';
import fashionPart2DesImg from '../../public/images/fashion-part2-des.png';
import fashionPart3DesImg from '../../public/images/fashion-part3-des.png';
import audioBannerImg from '../../public/images/audio-banner.png';
import audioBannerDesImg from '../../public/images/audio-banner-des.png';
import audioContentDesImg from '../../public/images/audio-content-des.png';
import digitalBannerBgImg from '../../public/images/digital-banner-bg.png';
import digitalBannerDesImg from '../../public/images/digital-banner-des.png';
import digitalContentDesImg from '../../public/images/digital-content-des.png';
import digitalDesPart1Img from '../../public/images/digital-des-part1.png';
import digitalDesPart2Img from '../../public/images/digital-des-part2.png';
import digitalDesPart3Img from '../../public/images/digital-des-part3.png';
import digitalDesPart4Img from '../../public/images/digital-des-part4.png';
import automotiveImg from '../../public/images/automotive.png';
import automotiveSelectImg from '../../public/images/automotive-select.png';
import fashionableLifeImg from '../../public/images/fashionable-life.png';
import fashionableLifeSelectImg from '../../public/images/fashionable-life-select.png';
import professionalAudioImg from '../../public/images/professional-audio.png';
import professionalAudioSelectImg from '../../public/images/professional-audio-select.png';
import digitalTransformationImg from '../../public/images/digital-transformation.png';
import digitalTransformationSelectImg from '../../public/images/digital-transformation-select.png';
import businessImg from '../../public/images/business.png';
import wanglei09Img from '../../public/images/wanglei09.png';
import chenyifei01Img from '../../public/images/chenyifei01.png';
import guanxiuli02Img from '../../public/images/guanxiuli02.png';
import guozhihui03Img from '../../public/images/guozhihui03.png';
import jiangzhixin04Img from '../../public/images/jiangzhixin04.png';
import likai05Img from '../../public/images/likai05.png';
import lina06Img from '../../public/images/lina06.png';
import meixinyuan07Img from '../../public/images/meixinyuan07.png';
import sunweijia08Img from '../../public/images/sunweijia08.png';
import storiesImg from '../../public/images/stories.png';
import barSelectImg from '../../public/images/bar-select.png';
import barNotSelectImg from '../../public/images/bar-not-select.png';
import prevIconImg from '../../public/images/prev-icon.png';
import nextIconImg from '../../public/images/next-icon.png';
import staffCareBgImg from '../../public/images/staff-care-bg.png';
import staffCareTitleImg from '../../public/images/staff-care-title.png';
import staffCareLeftPartImg from '../../public/images/staff-care-left-part.png';
import staffCareRightPartImg from '../../public/images/staff-care-right-part.png';
import evpBgImg from '../../public/images/evp-bg.png';
import evpPart1TitleImg from '../../public/images/evp-part1-title.png';
import evp1Img from '../../public/images/evp-1@2x.png';
import aloneTitleImg from '../../public/images/alone-title.png';
import evp2_1Img from '../../public/images/evp-2-1@2x.png';
import evp2_2Img from '../../public/images/evp-2-2@2x.png';
import evp2_3Img from '../../public/images/evp-2-3@2x.png';
import evp2_4Img from '../../public/images/evp-2-4@2x.png';

export default (props) => {
	const { activeIndex } = props;
	const pageSize = 15;
	const ecompIds = 8271933;
	const columns = [
		{
			title: '招聘职位名称',
			dataIndex: 'title',
			width: '40%',
			render: (text, record) => {
				return (
					<a href={record.url} target="_blank" rel="noreferrer">
						{text}
					</a>
				);
			},
		},
		{
			title: '工作地点',
			dataIndex: 'city',
			width: '20%',
		},
		{
			title: '经验要求',
			dataIndex: 'workYear',
			width: '20%',
		},
		{
			title: '发布时间',
			dataIndex: 'time',
			width: '20%',
		},
	];

	const AboutHuman = () => {
		return (
			<>
				<div className="about-human">
					<img className="title" alt="" src={aboutHumanImg} />
					<img className="human-content" alt="" src={humanValueImg} />
				</div>
			</>
		);
	};
	const HarmanPortfolio = () => {
		const imageList = [
			img2_1,
			img2_2,
			img2_3,
			img2_4,
			img2_5,
			img2_6,
			img2_7,
			img2_8,
			img2_9,
			img2_10,
			img2_11,
			img2_12,
			img2_13,
			img2_14,
			img2_17,
			img2_18,
		];
		return (
			<>
				<div className="harman-portfolio">
					<div className="harman-title" />
					<div className="image-wrapper_11">
						{imageList.map((src, index) => {
							return (
								<img
									className="image_7-0"
									key={`portfolio-${index}`}
									alt=""
									src={src}
								/>
							);
						})}
					</div>
				</div>
			</>
		);
	};
	// 首页 - 愿景使命
	const Mission = () => {
		return (
			<>
				<div className="mission">
					<img className="bg" src={missionImg} alt="" />
					<img className="mission-content" src={missionDescribeImg} alt="" />
				</div>
			</>
		);
	};

	// 首页 - 哈曼价值观
	const HumanValue = () => {
		const cardImageList = [
			integrityImg,
			innovateImg,
			teamworkImg,
			pardonImg,
			outstandingImg,
		];
		return (
			<>
				<div className="human-value">
					<div className="content">
						<img className="title" src={humanValuesImg} alt="" />
						<div className="wrap">
							{cardImageList.map((url, index) => {
								return <img src={url} key={`value-${index}`} alt="" />;
							})}
						</div>
					</div>
				</div>
			</>
		);
	};

	// 汽车事业部
	const TrimsManager = () => {
		return (
			<>
				<div className="car-pub">
					<div className="content">
						<div className="banner">
							<img className="bg" src={carBannerImg} alt="汽车俱乐部banner" />
							<img className="description" src={carDesImg} alt="" />
						</div>
						<div className="part1">
							<img src={part1DesImg} alt="" />
						</div>
						<div className="part2">
							<img src={part2Des1Img} alt="" />
							<img src={part2Des2Img} alt="" />
							<img src={part2Des3Img} alt="" />
						</div>
					</div>
				</div>
			</>
		);
	};

	// 时尚生活俱乐部
	const FashionClub = () => {
		return (
			<>
				<div className="car-pub fashion-club">
					<div className="content">
						<div className="banner">
							<img
								className="bg"
								src={fashionBannerImg}
								alt="时尚生活俱乐部banner"
							/>
							<img className="description" src={fashionDesImg} alt="" />
						</div>
						<div className="fashion-part1">
							<img src={fashionPart2DesImg} alt="" />
						</div>
						<div className="fashion-part2">
							<img src={fashionPart3DesImg} alt="" />
						</div>
					</div>
				</div>
			</>
		);
	};

	// 专业音视解决方案
	const AudioSolution = () => {
		return (
			<>
				<div className="audio-solution">
					<div className="content">
						<div className="banner">
							<img className="bg" src={audioBannerImg} alt="" />
							<img className="des" src={audioBannerDesImg} alt="" />
						</div>
						<div className="description">
							<img src={audioContentDesImg} alt="" />
						</div>
					</div>
				</div>
			</>
		);
	};

	// 数字化转型方案
	const DigitalTransformation = () => {
		return (
			<div className="digital-transformation">
				<div className="content">
					<div className="banner">
						<img className="bg" src={digitalBannerBgImg} alt="" />
						<img className="des" src={digitalBannerDesImg} alt="" />
					</div>
					<div className="description">
						<img src={digitalContentDesImg} alt="" />
					</div>
					<div className="part">
						<img className="part-image-info1" src={digitalDesPart1Img} alt="" />
						<img className="part-image-info2" src={digitalDesPart2Img} alt="" />
						<img className="part-image-info3" src={digitalDesPart3Img} alt="" />
						<img className="part-image-info4" src={digitalDesPart4Img} alt="" />
					</div>
				</div>
			</div>
		);
	};

	// 首页 - 我们的业务
	const Business = () => {
		const [activeIndex, setActiveIndex] = useState(0);

		const handleCardClick = (index) => {
			setActiveIndex(index);
		};

		const tabList = [
			{
				name: '汽车',
				url: automotiveImg,
				activeUrl: automotiveSelectImg,
			},

			{
				name: '时尚生活',
				url: fashionableLifeImg,
				activeUrl: fashionableLifeSelectImg,
			},
			{
				name: '专业音视解决方案',
				url: professionalAudioImg,
				activeUrl: professionalAudioSelectImg,
			},
			{
				name: '数字化转型方案',
				url: digitalTransformationImg,
				activeUrl: digitalTransformationSelectImg,
			},
		];
		return (
			<div className="business">
				<div className="content">
					<img className="title" src={businessImg} alt="我们的业务" />
					<div className="tab-wrap">
						{tabList.map((tabInfo, index) => {
							return (
								<div
									className="tab"
									key={`tab-${index}`}
									onClick={() => handleCardClick(index)}
								>
									<img
										src={
											index === activeIndex ? tabInfo.activeUrl : tabInfo.url
										}
										alt={tabInfo.name}
									/>
								</div>
							);
						})}
					</div>
					{activeIndex === 0 && <TrimsManager />}
					{activeIndex === 1 && <FashionClub />}
					{activeIndex === 2 && <AudioSolution />}
					{activeIndex === 3 && <DigitalTransformation />}
				</div>
			</div>
		);
	};

	// 工作在哈曼 - banner
	const WorkBanner = () => {
		const [curBannerIndex, setCurIndex] = useState(1);
		const bannerWrap = useRef();

		useEffect(() => {
			bannerWrap.current.style = `transform: translateX(-${
				curBannerIndex * 1325
			}px);`;
		}, [curBannerIndex]);

		useEffect(() => {
			if (bannerWrap.current) {
				// 监听Banner 运动完成
				const listenBannerTransition = () => {
					// 0 1 2 3 4 5 6 7 8 9 10
					//   1 2 3 4 5 6 7 8 9
					//   0 1 2 3 4 5 6 7 8
					if (curBannerIndex === 10) {
						setCurIndex(1);
						bannerWrap.current.style = `transition: none;
            transform: translateX(-${1 * 1325}px);`;
					}
					if (curBannerIndex === 0) {
						setCurIndex(9);
						bannerWrap.current.style = `transition: none;
            transform: translateX(-${9 * 1325}px);`;
					}
				};
				bannerWrap.current.addEventListener(
					'transitionend',
					listenBannerTransition,
					false
				);
				return () => {
					bannerWrap.current.removeEventListener(
						'transitionend',
						listenBannerTransition,
						false
					);
				};
			}
		}, [curBannerIndex]);

		const handleClickPrevBtn = () => {
			setCurIndex(() => {
				if (curBannerIndex === 0) {
					return 10;
				}
				return curBannerIndex - 1;
			});
		};

		const handleClickNextBtn = () => {
			setCurIndex(() => {
				if (curBannerIndex >= 10) {
					return 1;
				}
				return curBannerIndex + 1;
			});
		};

		const showSelectProgressBar = (index) => {
			return curBannerIndex - 1 >= index;
		};

		const handleClickProgressBar = (index) => {
			setCurIndex(index + 1);
		};

		const peoplesList = [
			wanglei09Img,
			chenyifei01Img,
			guanxiuli02Img,
			guozhihui03Img,
			jiangzhixin04Img,
			likai05Img,
			lina06Img,
			meixinyuan07Img,
			sunweijia08Img,
			wanglei09Img,
			chenyifei01Img,
		];
		return (
			<>
				<div className="work-banner">
					<div className="content">
						<img className="content-title" src={storiesImg} alt="" />
						<div className="banner" ref={bannerWrap}>
							{peoplesList.map((url, index) => {
								return <img src={url} key={`peoplesList-${index}`} alt="" />;
							})}
						</div>

						<div className="progress-bar">
							{new Array(9).fill('').map((_, index) => {
								return (
									<div
										onClick={() => handleClickProgressBar(index)}
										key={`progress-bar-${index}`}
									>
										<img
											src={
												showSelectProgressBar(index)
													? barSelectImg
													: barNotSelectImg
											}
											alt=""
										/>
									</div>
								);
							})}
						</div>
						<div className="prev-btn" onClick={() => handleClickPrevBtn()}>
							<img src={prevIconImg} alt="" />
						</div>
						<div className="next-btn" onClick={() => handleClickNextBtn()}>
							<img src={nextIconImg} alt="" />
						</div>
					</div>
				</div>
			</>
		);
	};

	// 工作在哈曼 - 员工关怀
	const StaffCare = () => {
		return (
			<>
				<div className="staff-care">
					<img className="bg" src={staffCareBgImg} alt="" />
					<div className="content">
						<img src={staffCareTitleImg} alt="" className="title" />
						<div className="introduce">
							<img src={staffCareLeftPartImg} alt="" />
							<img src={staffCareRightPartImg} alt="" />
						</div>
					</div>
				</div>
			</>
		);
	};

	// 工作在哈曼 - 全新的雇主品牌，全新的人才机遇
	const EmployerBrand = () => {
		return (
			<>
				<div className="employer-brand">
					<img className="bg" src={evpBgImg} alt="" />
					<div className="content">
						<img className="part1" src={evpPart1TitleImg} alt="" />
						<img src={evp1Img} alt="" className="part2" />
						<img src={aloneTitleImg} alt="" className="part3" />
						<div className="part4">
							<img src={evp2_1Img} alt="" />
							<img src={evp2_2Img} alt="" />
							<img src={evp2_3Img} alt="" />
							<img src={evp2_4Img} alt="" />
						</div>
					</div>
				</div>
			</>
		);
	};

	return (
		<div className="content">
			{/* 首页 */}
			{activeIndex === 0 && (
				<div>
					<AboutHuman />
					<HarmanPortfolio />
					<Mission />
					<HumanValue />
					<Business />
				</div>
			)}
			{/* 工作在哈曼 */}
			{activeIndex === 1 && (
				<div>
					<WorkBanner />
					<StaffCare />
					<EmployerBrand />
				</div>
			)}
			{/* 校园招聘 */}
			{activeIndex === 2 && (
				<div className="job-wrapper">
					<JobTable pageSize={pageSize} ecompIds={ecompIds} columns={columns} />
				</div>
			)}
		</div>
	);
};
